// Packages
import { useState } from 'react';

// Components
import ProcedureList from 'modules/Procedures/components/List';
import ProcedureCreateScreen from '../Create';
import AddIcon from 'components/BTDUI/icons/BTDFAB';
import ProcedureLayout from 'modules/Procedures/layouts';
import BTDPagination from 'components/BTDUI/BTDPagination';
import BTDProgress from 'components/BTDUI/BTDProgress';

// Other
import useApi from 'hooks/useApi';
import './styles.css'

const ProcedureScreen = () => {

    const [page, setPage] = useState(1);

    const { data: procedures, isLoading, meta, onChange } = useApi('/procedures?page=' + page + '&per_page=100');
    
    const [formActive, setFormActive] = useState(false);


    return(
        <ProcedureLayout title='Procedures'>

            <div className='ProcedureListScreen__filters'>

            </div>

            {meta && meta.length !== 0 &&
                <p className='ProcedureListScreen__text opacity'>Displaying {meta.from.toLocaleString()} to {meta.to.toLocaleString()} of {meta.total.toLocaleString()} procedures</p>
            }

            { isLoading ? 
                <>
                <div style={{ 
                    alignItems: 'center',
                    display: 'flex',
                    height: '40vh',
                    justifyContent: 'center',
                    width: '100%', 
                    }}
                >
                    <BTDProgress height={50} type='circular' width={50} />
                </div>
            </>
            :
                <ProcedureList 
                    isLoading={isLoading}  
                    items={procedures} 
                    onChange={() => {onChange()}}
                />
                }

            {meta && meta.total > meta.per_page &&
                <BTDPagination
                    currentPage={meta.current_page} 
                    totalPages={meta.last_page}
                    onChange={(value) => {
                        setPage(value);
                        onChange();
                    }}
                    style={{margin: '30px auto', width: 'max-content'}}
                />
            }	

            <AddIcon colour='#40506B' onClick={() => {
                setFormActive(true);
            }} />

            {formActive &&
                <ProcedureCreateScreen
                    onClose={() => {
                        setFormActive(false);
                    }} 
                    onSubmit={() => {
                        onChange();
                        setFormActive(false);
                    }} 
                />
            }

        </ProcedureLayout>
    )

}

export default ProcedureScreen;